"use client";
import React from "react";
import dynamic from "next/dynamic";

const MapPali = dynamic(
  () => import("@/components/sections/landing/mapPaliGis"),
  {
    ssr: false, // This will prevent server-side rendering of this component
  }
);

const MemberOverviewSection = () => {
  return (
    <section className="bg-[#F8F8F8]">
      <div className="container py-7">
        <h3 className="text-center text-primary-700 font-semibold text-xl md:text-3xl">
          Anggota Dewan Perwakilan Rakyat Daerah PALI
        </h3>
        <div className="text-center h-80 md:h-[40rem] mt-10">
          <MapPali />
        </div>
      </div>
    </section>
  );
};

export default MemberOverviewSection;
